import pdfIconNew from "@assets/article/pdfIconNew.svg";
import Link from "@elements/Typography/Link";
import { Attachment } from "@typings/Opensearch";
import { twMerge } from "tailwind-merge";

type AttachmentCardProps = {
  attachment: Attachment;
  className?: string;
};

export default function AttachmentCard({
  attachment,
  className,
}: AttachmentCardProps) {
  return (
    <div data-testid="attachment-pdf" className={twMerge("flex", className)}>
      <Link
        destination={attachment.content["attachmentLink-caas"]}
        relativePath={false}
        type="application/pdf"
        className="flex gap-[5px] items-center text-xxs font-secondary font-medium leading-[150%] text-blue-100 underline"
      >
        <img src={pdfIconNew} alt="pdf-icon" width={40} height={40} />
        {attachment.content.title}
      </Link>
    </div>
  );
}
